export enum WorkVestSizeEnum {
  SMALL = 'Small',
  MEDIUM = 'Medium',
  LARGE = 'Large',
  X_LARGE = 'X Large',
  XX_LARGE = '2X Large',
  XXX_LARGE = '3X Large',
  XXXX_LARGE = '4X Large',
}
